import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setLoadingGreenroom } from '@/store/slices/project';
import { getWorkingProjectSessions } from '@/store/slices/project/selectors';

export const useHandleGoToGreenroom = (searchParams?: string) => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const sessions = useAppSelector(getWorkingProjectSessions);

  const isSingleSession = sessions && sessions.length === 1;
  const session = isSingleSession ? sessions?.[0] : sessions?.find((s) => s.uuid === params.sessionUuid);

  return useCallback(() => {
    if (!session?.uuid) return;
    dispatch(setLoadingGreenroom(true));
    const search = searchParams ? `?${searchParams}` : '';
    window.open(`${import.meta.env.VITE_GREENROOM_REDIRECT}/create/${session.uuid}${search}`, '_blank');
  }, [dispatch, session?.uuid, searchParams]);
};
